<template>
  <div id="sedekah-kuy">
    <img
      src="../assets/bg-misi.webp"
      alt=""
      class="hidden xl:absolute right-0 w-full mt-10 xl:w-3/12 xl:-mt-16"
    />
    <h3
      class="karla md:text-lg xl:text-2xl text-cBlue font-semibold text-center tracking-wider mt-16 md:mt-40 xl:mt-40"
    >
      KALAU MAU SEDEKAH DI SeKuy GIMANA SIH ?
    </h3>
    <img
      src="../assets/bg-cara.svg"
      alt=""
      class="absolute -ml-12 inset-x-2/4 -mt-12"
    />
    <hr
      class="mx-auto w-7/12 md:w-4/12 lg:w-3/12 xl:w-3/12 border mt-3 border-cLightBlue"
    />
    <p
      class="mt-8 mx-6 text-sm md:text-sm md:mx-44 lg:mx-52 lg:px-8 xl:mx-72 xl:px-10 text-center xl:mt-10 tracking-wide xl:text-lg"
    >
      Jika teman-teman mau sedekah di SeKuy tinggal menghubungi
      <span class="text-cBlue font-semibold">Bendahara SeKuy.</span> Di SeKuy
      ada <span class="text-cBlue font-semibold">2 pilihan pemisah</span> untuk
      <span class="text-cBlue font-semibold">bersedekah.</span>
    </p>
    <div
      class="relative grid mx-10 gap-6 mt-10 md:grid-cols-2 lg:mx-40 xl:gap-8 xl:mx-80 xl:mt-12"
    >
      <div class="text-center shadow-lg pt-10 pb-5 px-7">
        <img src="../assets/cara-img.svg" alt="" class="mx-auto" />
        <h4 class="source text-2xl mt-8 mb-4 font-semibold">
          Sedekah Khusus Yatim
        </h4>
        <p class="text-left">
          Artinya sedekah ini khusus kami berikan untuk
          <span class="font-semibold text-cBlue">para yatim</span> dan tidak
          untuk agenda lain.
        </p>
        <div class="flex my-2 mt-8">
          <p class="text-red-500">*</p>
          <p class="ml-2 text-left">
            Donasi insyaAllah kami salurkan rutin tiap bulan ke antar panti yang
            berada di wilayah Tangerang Raya.
          </p>
        </div>
      </div>
      <div class="text-center shadow-lg pt-10 pb-5 px-7">
        <img src="../assets/cara-img.svg" alt="" class="mx-auto" />
        <h4 class="source text-2xl mt-8 mb-4 font-semibold">Sedekah Bebas</h4>
        <p class="text-left -mr-1">
          Artinya sedekah ini bersifat bebas dan uang donasinya pun di
          pergunakan
          <span class="font-semibold text-cBlue">bebas</span> untuk
          <span class="font-semibold text-cBlue">agenda apa saja</span> yang
          berkaitan dengan sosial dan berjalannya program agenda SeKuy.
        </p>
        <div class="flex my-2 mt-8">
          <p class="text-red-500">*</p>
          <p class="ml-2 xl:text-left xl:-mr-2">
            Jadi bersifat
            <span class="font-semibold text-cBlue">flexible</span>. Bisa buat
            tambahan donasi yatim, kaum dhuafa, program MAJU, dan aksi sosial
            lainnya.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cara",
};
</script>

<style>
</style>